import { api } from '../../http';
import { ObjectForSelection } from '../../types/interfaces/ObjectForSelection';
import { TaskProcessingProcess } from '../../types/interfaces/TaskProcessingProcess';

import Api from './api';
import ITaskProcessingProcessApi from './interfaces/taskProcessingProcessApi';

class TaskProcessingProcessApi
  extends Api<TaskProcessingProcess>
  implements ITaskProcessingProcessApi
{
  constructor(abortController: AbortController) {
    super('taskProcessingProcess/', abortController);
  }

  async getForSelection() {
    const apiCallResult = await api.get<ObjectForSelection[]>(
      'taskProcessingProcess/getForSelection',
      { signal: this._abortController.signal }
    );
    return apiCallResult?.data;
  }
}

export default TaskProcessingProcessApi;
